import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import { Translate } from '../../../../shared/LanguageService';
import { EditingStyle } from '../../types';

type EditingStylesListItemProps = {
    id: number;
    name: string;
    description: string | null;
    isActive: boolean;
    onEdit: (editingStyle: EditingStyle) => void;
};

export function EditingStylesListItem({
    id,
    name,
    description,
    isActive,
    onEdit
}: EditingStylesListItemProps) {
    return (
        <TableRow
            data-inactive={isActive ? undefined : 'true'}
            sx={{
                '&[data-inactive="true"]': {
                    backgroundColor: 'action.hover'
                },
                '&[data-inactive="true"] td': {
                    color: 'text.disabled'
                }
            }}
        >
            <TableCell sx={{ verticalAlign: 'top' }}>
                <Typography
                    variant="body1"
                    title={name}
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        maxWidth: 320,
                        fontWeight: '700',
                        fontSize: '16px'
                    }}
                >
                    {name}
                </Typography>
            </TableCell>
            <TableCell sx={{ verticalAlign: 'top' }}>
                <Typography
                    variant="body1"
                    sx={{
                        whiteSpace: 'normal',
                        overflowWrap: 'break-word',
                        fontStyle: 'italic'
                    }}
                >
                    {description}
                </Typography>
            </TableCell>
            <TableCell sx={{ verticalAlign: 'top' }}>
                <Button
                    startIcon={<EditIcon />}
                    variant="outlined"
                    sx={{ backgroundColor: 'background.paper' }}
                    onClick={() => onEdit({ id, name, description, isActive })}
                >
                    <Typography variant="body1">{Translate('edit')}</Typography>
                </Button>
            </TableCell>
        </TableRow>
    );
}
